/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { AuthPostLogin } from './authentication-login.post';

export const AuthenticationOauth2MicrosoftCallbackGet = {
  id: 'authentication.oauth2.microsoft.callback.get',
  tag: 'Authentication',
  summary: 'Callback for the Microsoft login over OAuth2',
  description: '',
  method: 'get',
  route: () => `/authentication/microsoft/callback`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: AuthPostLogin.response[200].content['application/json'].schema,
        },
      },
    },
  },
} as const satisfies Endpoint;
